import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

export const processTicketLifecycle = async (apiData, environment, logDbOperation, apiKey) => {
  try {
    // Processing ticket data

    logDbOperation('Ticket Processing Started', {
      recordCount: apiData.length,
      environment
    });

    const response = await axios.post(`${API_BASE_URL}/api/process-tickets`, {
      apiData,
      environment,
      apiKey
    });

    if (response.data.success) {
      // Processing successful

      logDbOperation('Ticket Processing Complete', {
        ticketsCreated: response.data.tickets?.length || 0,
        eventsCreated: response.data.events?.length || 0
      }, true);

      return {
        tickets: response.data.tickets || [],
        events: response.data.events || []
      };
    } else {
      logDbOperation('Ticket Processing Failed', {
        error: response.data.error,
        environment
      }, false);

      return {
        tickets: [],
        events: []
      };
    }
  } catch (error) {
    logDbOperation('Ticket Processing Failed', {
      error: error.message,
      environment
    }, false);

    return {
      tickets: [],
      events: []
    };
  }
};